// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {ListItem} from './index';

export function template(this: ListItem) {
  return (
    <div
      sel='.mp-list-item-container'
      class={{
        'mp-list-item-active': this.attr(`active`),
        'mp-list-item-static': this.attr(`static`),
        'mp-list-item-disabled': this.attr(`disabled`),
      }}
    >
      <slot />
    </div>
  );
}
